import { atom } from 'jotai';
import { atomWithStorage } from 'jotai/utils';
import { dodAtom } from '@components/metrics-panel-hz/atoms';

const annotationAtom = atomWithStorage('annotations', true);
const manualAlertAtom = atom(false);
const aiAlertAtom = atom(false);

const diagnosticsAtom = atom((get) => {
  return {
    manualAlert: get(manualAlertAtom),
    aiAlert: get(aiAlertAtom),
    dod: get(dodAtom),
  };
});

export { annotationAtom, manualAlertAtom, aiAlertAtom, diagnosticsAtom };
